/* eslint-disable react/prop-types */
import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import {
  addCartItem,
  increaseCartQuantity
} from '../../../../../redux/CartItem/actionCreators';
import { decreaseProductQuantity } from '../../../../../redux/ProductItem/actioCreators';

function ProductItem({ productItem }) {
  // Destructuring product item data from product object
  const {
    productId,
    productName,
    productCategory,
    productPrice,
    productQuantity,
    productImage,
    defaultProductQuantity,
  } = productItem;

  // useDispatch function to dispatch action to the redux store
  const dispatch = useDispatch();
  //Geeting from redux store
  const cartItems = useSelector(state => state.cartItems);

  const addCartHandler = productId => {
    // When the item not exist in the cart
    if (cartItems?.findIndex(item => item.productId === productId) === -1) {
      // batch update after completed all actions
      batch(() => {
        dispatch(
          addCartItem({
            productId,
            productName,
            productCategory,
            productImage,
            productPrice,
            remainingQuantity: productQuantity - 1,
            cartQuantity: 1,
            defaultProductQuantity,
          })
        );
        dispatch(decreaseProductQuantity(productId));
      });
    } else {
      // batch update after completed all actions
      batch(() => {
        dispatch(increaseCartQuantity(productId));
        dispatch(decreaseProductQuantity(productId));
      });
    }
  };

  return (
    <div className="lws-productCard">
      <img className="lws-productImage" src={`${productImage}`} alt="product" />
      <div className="p-4 space-y-2">
        <h4 className="lws-productName">{productName}</h4>
        <p className="lws-productCategory">{productCategory}</p>
        <div className="flex items-center justify-between pb-2">
          <p className="productPrice">
            BDT <span className="lws-price">{productPrice}</span>
          </p>
          <p className="productQuantity">
            QTY <span className="lws-quantity">{productQuantity}</span>
          </p>
        </div>
        <button
          className="lws-btnAddToCart"
          id="prasanto19-addToCart"
          disabled={!productQuantity}
          onClick={() => addCartHandler(productId)}
        >
          Add To Cart
        </button>
      </div>
    </div>
  );
}

export default ProductItem;
